function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Select, Tag, InputNumber, Divider, notification, List, Drawer, Space } from "antd";
import { Container, Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import AddItemCategory from "./AddItemCategory";
import { BoxFill } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EditBill = function EditBill(_ref) {
  var handler = _ref.handler,
    bill = _ref.bill;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showAddCategory = _useState8[0],
    setShowAddCategory = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    deptOptions = _useState0[0],
    setDeptOptions = _useState0[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState1 = useState(""),
    _useState10 = _slicedToArray(_useState1, 2),
    loadError = _useState10[0],
    setLoadError = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDataChanged = _useState12[0],
    setIsDataChanged = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    itemOptions = _useState14[0],
    setItemOptions = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    items = _useState16[0],
    setItems = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    selectedItems = _useState18[0],
    setSelectedItems = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    totalCash = _useState20[0],
    setTotalCash = _useState20[1];
  var onFinish = function onFinish(values) {
    values.items.forEach(function (item_id) {
      if (selectedItems.filter(function (i) {
        return i.id == item_id;
      }).length > 0) {
        var item = items.filter(function (i) {
          return i.id == item_id;
        })[0];
        var extElementQuant = selectedItems.filter(function (i) {
          return i.id == item.id;
        })[0].quantity;
        setSelectedItems(selectedItems.filter(function (i) {
          return i.id != item.id;
        }));
        setSelectedItems(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            id: item.id,
            label: item.label,
            quantity: extElementQuant + 1,
            price: item.price
          }]);
        });
        setTotalCash(function (prev) {
          return prev + item.price;
        });
      } else {
        var _item = items.filter(function (i) {
          return i.id == item_id;
        })[0];
        setSelectedItems(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            id: _item.id,
            label: _item.label,
            quantity: 1,
            price: _item.price
          }]);
        });
        setTotalCash(function (prev) {
          return prev + _item.price;
        });
      }
    });
  };
  var createInvoice = function createInvoice() {
    setIsFormLoading(true);
    var itemsArg = new Array();
    var itemsQuantityArg = new Array();
    selectedItems.forEach(function (i) {
      itemsArg.push(i.id);
      itemsQuantityArg.push(i.quantity);
    });
    axios.post(Common.baseApiUrl + "editinvoice", {
      id: bill.id,
      user_id: Common.currentUser.id,
      items: itemsArg,
      quantities: itemsQuantityArg,
      lead_id: bill.lead.id,
      total_amount: totalCash
    }).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        notification.error({
          message: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var handlePlus = function handlePlus(item) {
    if (selectedItems.filter(function (i) {
      return i.id == item.id;
    }).length > 0) {
      var extElementQuant = selectedItems.filter(function (i) {
        return i.id == item.id;
      })[0].quantity;
      setSelectedItems(selectedItems.filter(function (i) {
        return i.id != item.id;
      }));
      setSelectedItems(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.id,
          label: item.label,
          quantity: extElementQuant + 1,
          price: item.price
        }]);
      });
      setTotalCash(function (prev) {
        return prev + item.price;
      });
    } else {
      setSelectedItems(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.id,
          label: item.label,
          quantity: 1,
          price: item.price
        }]);
      });
      setTotalCash(function (prev) {
        return prev + item.price;
      });
    }
  };
  var handleMinus = function handleMinus(item) {
    //IF ITEM EXISTS IN THE LIST
    if (selectedItems.filter(function (i) {
      return i.id == item.id;
    }).length > 0) {
      //GET CURRENT QUANTITY
      var extElementQuant = selectedItems.filter(function (i) {
        return i.id == item.id;
      })[0].quantity;
      if (extElementQuant <= 0) {
        handleClearItem(item);
        return;
      }
      setSelectedItems(selectedItems.filter(function (i) {
        return i.id != item.id;
      }));
      setSelectedItems(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.id,
          label: item.label,
          quantity: extElementQuant - 1,
          price: item.price
        }]);
      });
      setTotalCash(function (prev) {
        return prev - item.price;
      });
    }
  };
  var handleClearItem = function handleClearItem(item) {
    if (selectedItems.filter(function (i) {
      return i.id == item.id;
    }).length > 0) {
      var extElementQuant = selectedItems.filter(function (i) {
        return i.id == item.id;
      })[0].quantity;
      setSelectedItems(selectedItems.filter(function (i) {
        return i.id != item.id;
      }));
      setTotalCash(function (prev) {
        return prev - item.price * extElementQuant;
      });
      //setSelectedItems(prev => [...prev, {id: item.id, label: item.label, quantity: extElementQuant + 1, base_price: item.base_price}]); 
    }
  };
  var handleCategoryChange = function handleCategoryChange(cid) {
    setItemOptions([]);
    items.filter(function (i) {
      return i.item_category_id == cid;
    }).forEach(function (i) {
      setItemOptions(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          value: i.id,
          label: i.label
        }]);
      });
    });
  };
  useEffect(function () {
    setIsDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + 'getitemcategories/' + Common.currentUser.id), axios.get(Common.baseApiUrl + 'getitems/' + Common.currentUser.id)]).then(function (response) {
      if (response[0].data.status == 200) {
        setDeptOptions([]);
        response[0].data.categories.forEach(function (s) {
          setDeptOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: s.id,
              label: s.label
            }]);
          });
        });
      } else {
        setLoadError(response[0].data.message);
      }
      if (response[1].data.status == 200) {
        setItemOptions([]);
        setItems([]);
        response[1].data.items.forEach(function (i) {
          setItemOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: i.id,
              label: i.label
            }]);
          });
        });
        setItems(response[1].data.items);
      }
    })["catch"](function (error) {
      setLoadError('Une erreur est survenue');
    })["finally"](function () {});
  }, [isDataChanged]);
  useEffect(function () {
    bill.bill_items.forEach(function (i) {
      setSelectedItems(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: i.id,
          label: i.item.label,
          quantity: i.quantity,
          price: i.item.price
        }]);
      });
      setTotalCash(function (prev) {
        return prev + i.item.price;
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), loadError.length > 0 && /*#__PURE__*/_jsx("div", {
      style: {
        padding: "10px 0px 10px 0px"
      },
      children: /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: loadError,
        showIcon: true
      })
    }), /*#__PURE__*/_jsx(Form, {
      layout: "vertical",
      form: form,
      onFinish: onFinish,
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "item_category_id",
              label: "Cat\xE9gorie",
              children: /*#__PURE__*/_jsx(Select, {
                onChange: handleCategoryChange,
                placeholder: "Choisir une cat\xE9gorie",
                options: deptOptions,
                rules: [{
                  required: true,
                  message: 'Ce champs est obligatoire'
                }]
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "items",
              label: "Produit | Service",
              children: /*#__PURE__*/_jsx(Select, {
                mode: "multiple",
                placeholder: "Choisir une element",
                options: itemOptions,
                rules: [{
                  required: true,
                  message: 'Ce champs est obligatoire'
                }]
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: " ",
              children: /*#__PURE__*/_jsx(Button, {
                htmlType: "submit",
                disabled: deptOptions.length == 0,
                loading: isFormLoading,
                type: "default",
                children: /*#__PURE__*/_jsx("b", {
                  children: "AJOUTER AU DEVIS"
                })
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs("h4", {
      children: [/*#__PURE__*/_jsx("b", {
        children: "CLIENT: "
      }), bill.lead.name]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        minHeight: "400px",
        padding: "10px"
      },
      children: [/*#__PURE__*/_jsx(List, {
        dataSource: selectedItems,
        itemLayout: "horizontal",
        renderItem: function renderItem(item, index) {
          return /*#__PURE__*/_jsx(List.Item, {
            actions: [/*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: function onClick() {
                handlePlus(item);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: "PLUS"
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "link",
              disabled: item.quantity <= 1,
              onClick: function onClick() {
                handleMinus(item);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: "MOINS"
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: function onClick() {
                handleClearItem(item);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: "RETIRER"
              })
            })],
            children: /*#__PURE__*/_jsx(List.Item.Meta, {
              avatar: /*#__PURE__*/_jsx(BoxFill, {
                size: 16
              }),
              title: item.label,
              description: /*#__PURE__*/_jsxs(Space, {
                children: [/*#__PURE__*/_jsxs("span", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Prix : "
                  }), item.price.toLocaleString("Fr")]
                }), /*#__PURE__*/_jsxs("span", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Qte : "
                  }), item.quantity]
                })]
              })
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "TOTAL : "
        }), totalCash.toLocaleString("Fr")]
      }), /*#__PURE__*/_jsx("br", {})]
    }), /*#__PURE__*/_jsx(Button, {
      type: "primary",
      disabled: selectedItems.length == 0,
      loading: isFormLoading,
      onClick: function onClick() {
        createInvoice();
      },
      children: isFormLoading ? /*#__PURE__*/_jsx("b", {
        children: "MISE A JOUR DU DEVIS EN COURS"
      }) : /*#__PURE__*/_jsx("b", {
        children: "METTRE A JOUR"
      })
    })]
  });
};
export default EditBill;